import React from 'react'

import classes from '../Card.scss'

const footer = ({ className, children }) => {
  return <div className={[classes.Footer, className].join(' ')}>{children}</div>
}

export default footer
